import { TTransactionType } from "~/src/types/transactions";

type TTransactionTypeDisplayMap = { [key in TTransactionType]: string };
export const TRANSACTION_TYPE_DISPLAY_MAP: TTransactionTypeDisplayMap = {
  DEPOSIT: "Deposit",
  EXPENSE: "Expense",
  JOURNAL_ENTRY: "Journal Entry",
  CREDIT_CARD_CREDIT: "Credit Card Credit",
};
